@if (sliderLabels?.axis || sliderLabels?.min || sliderLabels?.max) {
  <div
    ngClass="z-label z-label-{{ axis }}"
    [class.z-without-title]="!sliderLabels?.axis"
    [class.z-without-min-max]="!sliderLabels?.min && !sliderLabels?.max"
  >
    @if (sliderLabels?.min || sliderLabels?.max) {
      <div class="z-label-value">
        @for (side of ['min', 'max']; track side) {
          <div
            [style.color]="color"
            [style.text-shadow]="textShadow | safeStyle"
            ngClass="z-label-value-{{ side }} z-texts-label"
            labelOverflow="axis"
          >
            {{ (sliderLabels ? sliderLabels[side] : '') | translateText: side + (axis ? '-' + axis : '') : data }}
          </div>
        }
      </div>
    }
    @if (sliderLabels?.axis) {
      <div
        [style.color]="color"
        [style.text-shadow]="textShadow | safeStyle"
        class="z-label-title z-texts-label-bold"
        labelOverflow="title"
      >
        {{ sliderLabels?.axis | translateText: 'axis' + (axis ? '-' + axis : '') : data }}
      </div>
    }
  </div>
}
